import { useSelector } from 'react-redux';
import { PermissionOption, IUser } from '../../../libraries/user';
import { LoginState } from '../../client-redux/login/reducer';
import { AppState } from '../../client-redux/reducers';
import ModalComponent from '../../components/modal';
import { Language } from '../../languages/languageHandler';
import UserForm, { UserFormMode } from './user-form';

interface UserModalProps {
  show: boolean;
  mode: UserFormMode;
  user: IUser;
  lang: Language;
  permissionOptions: PermissionOption[];
  onClose: () => void;
  onUserAdded?: () => void;
  OnUserDeleted?: (uid: number) => void;
}

const UserModal = ({
  show,
  mode,
  user,
  lang,
  permissionOptions,
  onClose,
  onUserAdded,
  OnUserDeleted
}: UserModalProps) => {
  const loginInfo = useSelector<AppState, LoginState>(state => state.login);

  const baseUser: IUser = {
    entid: loginInfo.user.entid || 0,
    uid: null,
    lang: loginInfo.user.lang || 0,
    region: loginInfo.user.region || 'Europe/Lisbon'
  };

  return (
    <ModalComponent
      show={show}
      handleClick={onClose}
      title={mode === UserFormMode.CREATE ? lang.USER_NEW : user.name}
      content={
        <UserForm
          mode={mode}
          isNew={mode === UserFormMode.CREATE}
          user={mode === UserFormMode.CREATE ? baseUser : user}
          lang={lang}
          permissionOptions={permissionOptions}
          togglePermissions={() => {}}
          onSuccess={() => {
            onClose();
            onUserAdded?.();
          }}
          onError={() => {}}
          onDelete={() => {
            if (user?.uid != null) {
              OnUserDeleted?.(user.uid);
            }
          }}
        />
      }
    />
  );
};

export default UserModal;
